import { httpsCallable } from 'firebase/functions'
import { functions } from '@/config/firebase'
import type { Role } from '@/types/user'

export interface CreateUserInput {
  name: string
  email: string
  password: string
  role: Role
}

/** Admin-only callables (enforced server-side). Each throws a FirebaseError. */

export async function createUser(input: CreateUserInput): Promise<{ uid: string }> {
  const call = httpsCallable<CreateUserInput, { uid: string }>(functions, 'createUser')
  const result = await call(input)
  return result.data
}

export async function setUserRole(uid: string, role: Role): Promise<void> {
  await httpsCallable(functions, 'setUserRole')({ uid, role })
}

export async function setUserSuspended(uid: string, suspended: boolean): Promise<void> {
  await httpsCallable(functions, 'setUserSuspended')({ uid, suspended })
}

export async function resetUserPassword(uid: string, password: string): Promise<void> {
  await httpsCallable(functions, 'resetUserPassword')({ uid, password })
}

export async function deleteUser(uid: string): Promise<void> {
  await httpsCallable(functions, 'deleteUser')({ uid })
}
